import { render, staticRenderFns } from "./HeroImage-paris.vue?vue&type=template&id=55e628aa&scoped=true&"
import script from "./HeroImage-paris.vue?vue&type=script&lang=js&"
export * from "./HeroImage-paris.vue?vue&type=script&lang=js&"
import style0 from "./HeroImage-paris.vue?vue&type=style&index=0&id=55e628aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e628aa",
  null
  
)

export default component.exports